import type { WebContainer } from '@webcontainer/api';
import { workbenchStore } from '../../stores/workbench';

function normalizeAssetPath(filePath: string): string {
  return filePath.replace(/\\/g, '/').replace(/^\/+/, '');
}

/**
 * Write a binary asset into WebContainer FS and track it in `workbenchStore.assets`.
 * Does not touch the text `files` store (assets are not editor content).
 */
export async function persistAssetFile(
  webcontainer: WebContainer,
  filePath: string,
  base64: string,
  mimeType?: string,
): Promise<void> {
  const normalized = normalizeAssetPath(filePath);
  if (!normalized) return;

  const existing = workbenchStore.assets.get()[normalized];
  if (existing?.base64 === base64) {
    return;
  }

  const bytes = Uint8Array.from(atob(base64), (c) => c.charCodeAt(0));
  const dir = normalized.includes('/') ? normalized.substring(0, normalized.lastIndexOf('/')) : '';
  if (dir) {
    await webcontainer.fs.mkdir(dir, { recursive: true });
  }
  await webcontainer.fs.writeFile(normalized, bytes);
  workbenchStore.assets.setKey(normalized, { base64, mimeType });
}

/** Register asset bytes in the store without writing to WebContainer (e.g. snapshot restore batch). */
export function registerAssetInStore(filePath: string, base64: string, mimeType?: string): void {
  const normalized = normalizeAssetPath(filePath);
  if (!normalized) return;
  workbenchStore.assets.setKey(normalized, { base64, mimeType });
}

export function bytesToBase64(bytes: Uint8Array): string {
  let binary = '';
  for (let i = 0; i < bytes.length; i++) {
    binary += String.fromCharCode(bytes[i]!);
  }
  return btoa(binary);
}
